import React from "react";
import { useAppSelector } from "../../Global/Store";
import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children }: any) => {
  const getUser = useAppSelector((state) => state?.currentUser);
  const consultant = useAppSelector((state) => state?.consultUser);

  if (getUser?.next_of_kin) {
    return children;
  } else if (consultant?.bankName) {
    return children;
  } else {
    <Navigate to={"/signin"} />;
  }
};

// private Route for dashboard
